<!--
    file type .....: HTML file: mailmessages.component.html
    Created By ....: ianday
    Date ..........: 1/10/24 
-->
<div class="mailmessages-container">
    <div class="userhelp-style">
        Click on a row to see the detail
    </div>
    <div class="new-email-ribbon-style" *ngIf="sendMessages === true" >
        <button mat-button class="command-button"
                [disabled]="!enableEmail || _readOnly"
                matTooltip="Send a pre-defined email message"
                (click)="openMailDialog()">
            <mat-icon>mail_outline</mat-icon>
            Send e-mail
        </button>

    </div>
    <!-- history table -->
    <div class="table-container mat-elevation-z1"
         (keydown)="tableKeyDown($event)" tabindex="-1">

        <table mat-table [dataSource]="dataSource" style="width:100%">

            <!-- date Sent -->
            <ng-container matColumnDef="dateSent">
                <th mat-header-cell *matHeaderCellDef
                    class="mat-table-header-style-dark mat-table-header-style-override "
                    style="width:30%">Date Sent
                </th>
                <td mat-cell class="mat-table-detail-override"
                    style="width:30%!important;padding-left:3px; text-align:left;"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{ lblFunction(element.dateSent) }}
                </td>
            </ng-container>

            <!-- subject -->
            <ng-container matColumnDef="subject">
                <th mat-header-cell *matHeaderCellDef
                    class="mat-table-header-style-dark mat-table-header-style-override "
                    style="width: 70%">
                    Subject
                </th>
                <td mat-cell class="mat-table-detail-override" style="width:70%"
                    *matCellDef="let element;let tableRowIdx = index;">
                    {{ element.subject }}
                </td>
            </ng-container>

            <!-- Recipients -->
            <ng-container matColumnDef="sentTo">
                <th mat-header-cell *matHeaderCellDef
                    class="mat-table-header-style-dark mat-table-header-style-override "
                    style="width:200px;">Recipients
                </th>
                <td mat-cell class="mat-table-detail-override" style="width:200px!important;"
                    *matCellDef="let element">{{ element.sentTo }}
                </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
            <tr mat-row
                *matRowDef="let row; columns: displayedColumns; let tableRowIdx = index;"
                [ngClass]="{'row-selected': tableRowIdx == Idx}"
                (click)="onRowClicked(row)">
            </tr>
        </table>
        <app-dw-spinner [visible]="busyCursor"></app-dw-spinner>
    </div>

    <!--- DETAIL SECTION --->
    <div class="detail-section">
        <div class="dwform dwform-cell-nopadding"
             style="min-width: 300px;padding-left: 0px; height: 300px;">  <!--RHS Fields -->

        <div class="dwform-row-gap-half"></div>
        <div class="dwform-row">
            <label class="label-field label-field-override">Agency:</label>
            <span class="form-required"></span>
            <label class="label-field-data label-field-data-override">{{selectedRecord?.agencyName}}</label>
        </div>

        <div class="dwform-row-gap-half"></div>
        <div class="dwform-row">
            <label class="label-field label-field-override">Date:</label>
            <span class="form-required"></span>
            <label class="label-field-data label-field-data-override">{{selectedRecord?.dateSent}}</label>
        </div>

        <div class="dwform-row-gap-half"></div>
        <div class="dwform-row">
            <label class="label-field label-field-override">To:</label>
            <span class="form-required"></span>
            <label class="label-field-data label-field-data-override">{{limitText(selectedRecord?.sentTo)}}</label>
        </div>

        <div class="dwform-row-gap-half"></div>
        <div class="dwform-row">
            <label class="label-field label-field-override">cc:</label>
            <span class="form-required"></span>
            <label class="label-field-data label-field-data-override">{{limitText(selectedRecord?.sentCc)}}</label>
        </div>

        <div class="dwform-row-gap-half"></div>
        <div class="dwform-row">
            <label class="label-field label-field-override">Subject:</label>
            <span class="form-required"></span>
            <label class="label-field-data label-field-data-override">{{limitText(selectedRecord?.subject)}}</label>
        </div>

        <div class="dwform-row-gap"></div>
        <div class="dwform-row">
            <label class="label-field label-field-override" style="padding-bottom:3px;">Message:</label>
            <span class="form-required"> </span>
            <textarea class="ta-message-override "
                readonly="true">{{selectedRecord?.messageBody}}</textarea>
        </div>
    </div>

</div>

<p-dialog header="Message Detail" [focusOnShow]="false"
          [(visible)]="openNewMailDialog" [modal]="true"
          [style]="{width: '1100px', height: '775px'}"
          appendTo="body"
          [minY]="35" [resizable]="false" [closable]="false" >
    <app-newmessage #newMessage
        [selectedRequest]="selectedRequest"
        [tableName]="_tableName"
        (submitClicked)="submitNewMessage($event)"
        (cancelClicked)="openNewMailDialog=false">
    </app-newmessage>
</p-dialog>
